<h2 mat-dialog-title>{{ title }}</h2>
<mat-dialog-content>
  @if (data.canApproveDeny) {
    <mat-form-field appearance="outline" class="full-width">
      <mat-label i18n="@@review.comment.label">Comment (optional)</mat-label>
      <textarea matInput [(ngModel)]="comment" rows="3"></textarea>
    </mat-form-field>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (data.canApproveDeny) {
    <button mat-raised-button color="primary" (click)="approve()">{{ approveLabel }}</button>
    <button mat-raised-button color="warn" (click)="deny()">{{ denyLabel }}</button>
  }
  @if (data.canRetrySend) {
    <button mat-raised-button color="primary" (click)="send()">{{ sendLabel }}</button>
  }
  <button mat-button (click)="cancel()">{{ cancelButtonLabel }}</button>
</mat-dialog-actions>
